import { Box } from '@mui/material';
import { OptionChainWithExpiryType } from 'app/pages/Simulator';
import { PositionMetaData, PositionWithExpiryData } from '../types';
import PositionCustomTable from './PositionCustomTable';
import moment from 'moment';

const PositionTab = ({
  positionsWithExpiry,
  optionChainData,
  lotSize,
  date,
  currentExpiryDate,
  updatePositions,
  removePosition,
}: {
  positionsWithExpiry: PositionWithExpiryData;
  optionChainData: OptionChainWithExpiryType;
  lotSize: number;
  date: string;
  currentExpiryDate: string;
  updatePositions: (positions: PositionMetaData) => void;
  removePosition: (position: PositionMetaData) => void;
}) => {
  const positions = convertPositionsMetaData(positionsWithExpiry, date);

  const handleClick = () => {
    //
  };

  return (
    <Box>
      <PositionCustomTable
        optionChainData={optionChainData}
        handleOptionClick={handleClick}
        updatePositions={updatePositions}
        positions={positions}
        date={date}
        lotSize={lotSize}
        removePosition={removePosition}
        currentExpiryDate={currentExpiryDate}
      />
    </Box>
  );
};

export default PositionTab;

export const convertPositionsMetaData = (
  positionsWithExpiryData: PositionWithExpiryData,
  selectedDate: string,
) => {
  let positions: PositionMetaData[] = [] as PositionMetaData[];
  positions = Object.values(positionsWithExpiryData)
    .map(position => Object.values(position))
    .flat();
  // Set isActive to false for positions with entryTime in the future (compared to selectedDate)
  const selected = moment(selectedDate, 'YYYY-MM-DD HH:mm:ss');
  positions.forEach(pos => {
    const entryTime = Object.values(pos.positionCandleWise)[0]?.entryTime;
    if (entryTime && moment(entryTime, 'YYYY-MM-DD HH:mm:ss').isAfter(selected)) {
      pos.isActive = false;
    }
  });
  return positions;
  }
